import { useQuery } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router';
import { api } from './api/cliente';
import { Trilho } from './componentes/Trilho';
import { Carregando, Vazio } from './componentes/base';
import { PaginaCalculadora } from './paginas/Calculadora';
import { PaginaClinicas } from './paginas/Clinicas';
import { PaginaCobrancas } from './paginas/Cobrancas';
import { PaginaConfiguracoes } from './paginas/Configuracoes';
import { PaginaDevedores } from './paginas/Devedores';
import { PaginaEntrar } from './paginas/Entrar';
import { PaginaEquipe } from './paginas/Equipe';
import { PaginaFechamentos } from './paginas/Fechamentos';
import { PaginaFichaDevedor } from './paginas/FichaDevedor';
import { PaginaImportar } from './paginas/Importar';
import { PaginaModelos } from './paginas/Modelos';
import { PaginaPagamentos } from './paginas/Pagamentos';
import { PaginaPainel } from './paginas/Painel';
import { PaginaRelatorios } from './paginas/Relatorios';
import { PaginaTriagem } from './paginas/Triagem';
import { useSessao } from './sessao/SessaoProvedor';

/** Contagens dos selos do trilho — recarregadas junto com as telas. */
function useContagens() {
  const { data } = useQuery({
    queryKey: ['contagens'],
    queryFn: async () => {
      const [fila, triagem] = await Promise.all([
        api.buscar<{ total: number }>('/cobranca/fila', { limite: 1 }),
        api.buscar<unknown[]>('/painel/candidatos-judicial'),
      ]);
      return { fila: fila.total, triagem: Array.isArray(triagem) ? triagem.length : 0 };
    },
    // Um minuto: a fila muda ao longo do dia, mas não a cada segundo.
    staleTime: 60_000,
  });
  return data ?? { fila: 0, triagem: 0 };
}

function Aplicacao() {
  const contagens = useContagens();

  return (
    <div className="flex min-h-dvh">
      <Trilho contagens={contagens} />
      <main className="min-w-0 flex-1 px-8 py-7">
        <Routes>
          <Route path="/" element={<Navigate to="/painel" replace />} />
          <Route path="/painel" element={<PaginaPainel />} />
          <Route path="/cobrancas" element={<PaginaCobrancas />} />
          <Route path="/devedores" element={<PaginaDevedores />} />
          <Route path="/devedores/:id" element={<PaginaFichaDevedor />} />
          <Route path="/triagem" element={<PaginaTriagem />} />
          <Route path="/pagamentos" element={<PaginaPagamentos />} />
          <Route path="/fechamentos" element={<PaginaFechamentos />} />
          <Route path="/clinicas" element={<PaginaClinicas />} />
          <Route path="/relatorios" element={<PaginaRelatorios />} />
          <Route path="/calculadora" element={<PaginaCalculadora />} />
          <Route path="/importar" element={<PaginaImportar />} />
          <Route path="/modelos" element={<PaginaModelos />} />
          <Route path="/equipe" element={<PaginaEquipe />} />
          <Route path="/configuracoes" element={<PaginaConfiguracoes />} />
          <Route path="*" element={<Vazio titulo="Página não encontrada." />} />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  const { usuaria, carregando } = useSessao();

  if (carregando) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-tinta-950">
        <Carregando>
          <span className="text-tinta-500">Abrindo o sistema…</span>
        </Carregando>
      </div>
    );
  }

  return usuaria ? <Aplicacao /> : <PaginaEntrar />;
}
